// extracted by mini-css-extract-plugin
module.exports = {"personHolder":"SendEmailAttendee_personHolder__30JpN","brandDisplay":"SendEmailAttendee_brandDisplay__OvZ2u","sentPreviousDisplay":"SendEmailAttendee_sentPreviousDisplay__377bJ"};